import React from 'react';
import CoreLayout from './layouts/PageLayout/PageLayout';

export const Route404 = (store) => {
  return ({
    path        : '*',
    exact       : true,
    component   : props => {
      return (
        <CoreLayout store={store} {...props}>
          <br />
          <h4 style={{ textAlign: 'center', margin: '20px' }}>404</h4>
          <p style={{ textAlign: 'center' }}>Sorry but we cannot find the page you are looking for. <a href='https://www.paragonone.com'>Return Home ?</a></p>
        </CoreLayout>
      );
    },
  });
};

export default Route404;



// WEBPACK FOOTER //
// ./src/routes/404/index.js